// extracted by mini-css-extract-plugin
module.exports = {"err":"css_err__d_vh_","btn":"css_btn__TxITW","holder":"css_holder__Olg1K","images":"css_images__9IsLc","content":"css_content__7e0Mn"};